import React from 'react';

import WizardStep from '../WizardStep';
import ChoiceButton from '../ChoiceButton';


const MedicareStatus = props => {
	const {
		setFieldValue,
		values,
		onButtonClick
	} = props;

	return (
		<WizardStep>
			<div className="question row">
				<div className="question__col">
					<h3>Are you currently enrolled in both Medicare Parts A & B?</h3>
					<div className="row">
						<div className="col">
							<ChoiceButton
								values={values}
								className="btn btn-list-select no-width"
								type="submit"
								name="medicare_status"
								value="Enrolled"
								setFieldValue={setFieldValue}
								onButtonClick={onButtonClick}
							>
								Yes
							</ChoiceButton>
							<ChoiceButton
								values={values}
								className="btn btn-list-select no-width"
								type="submit"
								name="medicare_status"
								value="Not Enrolled"
								setFieldValue={setFieldValue}
								onButtonClick={onButtonClick}
							>
								No
							</ChoiceButton>
							<ChoiceButton
								values={values}
								className="btn btn-list-select no-width"
								type="submit"
								name="medicare_status"
								value="Not Sure"
								setFieldValue={setFieldValue}
								onButtonClick={onButtonClick}
							>
								Not Sure (that's okay)
							</ChoiceButton>
						</div>
					</div>
				</div>
			</div>
		</WizardStep>
	);
};

export default MedicareStatus;
